<template>
    <main>

        <div class="row">

            <div class="col-sm-12" v-if="podeEditar">
                <form-create v-if="dialogCreate" :questao-pergunta-id="questaoPerguntaId" @on-saved="onSaved()" @on-back="hideAll()" />
            </div>

            <div class="col-sm-12" v-if="podeEditar">
                <form-edit v-if="dialogEdit" :questao-pergunta-id="questaoPerguntaId" :questao-resposta-id="questaoRespostaId" @on-saved="onSaved()" @on-back="voltarCriarRespostas()" />
            </div>

            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Resposta</th>
                                <th>Correta?</th>

                                <th class="text-center" width="150" v-if="podeEditar"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <td><span v-html="item.resposta"></span></td>
                                <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ehCorreta, 'badge-danger': !item.ehCorreta }">{{item.ehCorreta ? 'Sim' : 'Não'}}</span></td>

                                <td class="text-center" v-if="podeEditar">
                                    <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ questaoRespostaId: item.questaoRespostaId })">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger" @click="executeRemove({ questaoRespostaId: item.questaoRespostaId })">
                                        <i class="fa fa-trash-o"></i>
                                    </button>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </main>



</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'questaoperguntaresposta',
        mixins: [base],
        props: { questaoPerguntaId: Number, podeEditar: Boolean },
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'questaoperguntaresposta',
                    remove: 'questaoperguntaresposta'
                },

                dialogCreate: true,
                dialogEdit: false,
                podeDigitarResposta: true,
                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            voltarCriarRespostas: function () {
                this.dialogEdit = false;
                this.dialogCreate = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            openEdit: function (model) {
                this.questaoRespostaId = model.questaoRespostaId;
                this.dialogEdit = true;
                this.dialogCreate = false;
            },
            onSaved: function () {
                this.executeLoad();
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },

            executeLoad: function () {
                this.showLoading();
                this.filter.questaoPerguntaId = this.questaoPerguntaId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            console.log("questaoPerguntaId", this.questaoPerguntaId)
            this.executeFilter();
        }

    };
</script>